import { RefObject, useEffect, useRef, useState } from "react"
import { useAppState } from "../context/appStateContext"
import native from "../native/native"

export default function useSwitchToBasicShown(
  scrollContainerRef: RefObject<HTMLElement | null>,
  switchToBasicRef: RefObject<HTMLElement | null>,
  fixedFooterRef?: RefObject<HTMLElement | null>,
  enabled: boolean = true,
) {
  const hasFiredRef = useRef(false)
  const [hasBeenShown, setHasBeenShown] = useState(false)

  const { productData } = useAppState().state

  useEffect(() => {
    if (!enabled || !productData || hasFiredRef.current) return
    if (window.innerHeight < 300) return

    const btn = switchToBasicRef.current
    const root = scrollContainerRef.current
    if (!btn || !root) return

    let observer: IntersectionObserver | null = null

    const timer = setTimeout(() => {
      const footerHeight =
        fixedFooterRef?.current?.getBoundingClientRect().height ?? 0
      const rootMargin =
        footerHeight > 0 ? `0px 0px -${footerHeight}px 0px` : undefined

      observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting && !hasFiredRef.current) {
            hasFiredRef.current = true
            setHasBeenShown(true)
            native.logMixpanelEvent("html_switch_to_basic_shown")
            observer?.disconnect()
          }
        },
        { root, rootMargin, threshold: 1.0 },
      )

      observer.observe(btn)
    }, 300)

    return () => {
      clearTimeout(timer)
      observer?.disconnect()
    }
  }, [
    productData,
    enabled,
    fixedFooterRef,
    scrollContainerRef,
    switchToBasicRef,
  ])

  return hasBeenShown
}
